<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div id="report">
			<div class="md-layout" v-if="loaded">
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="display: flex; justify-content: space-between;">
					<h4>ទិន្នន័យសរុបទាំងអស់</h4>
					<a :href="'#/print_report'" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>បោះពុម្ភរបាយការណ៍</md-tooltip>
						</md-button>
					</a>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>groups</md-icon>
						</template>

						<template slot="content">
							<p class="category">អតិថិជនសរុប</p>
							<h3 class="title">{{stat.total_client}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>home_work</md-icon>
						</template>
						<template slot="content">
							<p class="category">គម្រោងសរុប</p>
							<h3 class="title">{{stat.total_project}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>supervised_user_circle</md-icon>
						</template>
						<template slot="content">
							<p class="category">អ្នកគ្រប់គ្រងសរុប</p>
							<h3 class="title">{{stat.total_admin}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>real_estate_agent</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនរំលោះកំពុងដំណើរការ</p>
							<h3 class="title">{{stat.total_loan - stat.total_finish_loan}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>real_estate_agent</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនរំលោះបានបញ្ចប់</p>
							<h3 class="title">{{stat.total_finish_loan}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>real_estate_agent</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនរំលោះសរុប</p>
							<h3 class="title">{{stat.total_loan}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនប្រាក់ដើមបានបង់</p>
							<h3 class="title">{{config.moneylify(stat.total_paid_principal)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនប្រាក់ដើមមិនទាន់បង់</p>
							<h3 class="title">{{config.moneylify(stat.total_principal - stat.total_paid_principal)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនប្រាក់ដើមសរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_principal)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនការប្រាក់បានបង់</p>
							<h3 class="title">{{config.moneylify(stat.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនការប្រាក់មិនទាន់បង់</p>
							<h3 class="title">{{config.moneylify(stat.total_interest - stat.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនការប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_interest)}}</h3>
						</template>
					</stats-card>
				</div>


				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h4>ការប្រមូលប្រាក់ប្រចាំខែ{{config.monthKHList[(new Date()).getMonth()]}}</h4>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនប្រាក់ដើមបានប្រមូល / ចំនួនប្រាក់ដើមត្រូវប្រមូល</p>
							<h3 class="title">{{config.moneylify(stat_monthly_payment.total_paid_principal)}} / <b>{{config.moneylify(stat_monthly_payment.total_principal)}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនការប្រាក់បានប្រមូល / ចំនួនការប្រាក់ត្រូវប្រមូល</p>
							<h3 class="title">{{config.moneylify(stat_monthly_payment.total_paid_interest)}} / <b>{{config.moneylify(stat_monthly_payment.total_interest)}}</b></h3>
						</template>
					</stats-card>
				</div>


				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="display: flex; justify-content: space-between;">
					<h4>ប្រាក់ចំណូលថ្ងៃនេះ ({{(new Date()).getDate()}}/{{(new Date()).getMonth()+1}}/{{(new Date()).getFullYear()}})</h4>
					<a :href="'#/print_daily_report'" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>បោះពុម្ភរបាយការណ៍</md-tooltip>
						</md-button>
					</a>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ដើមបានទូទាត់</p>
							<h3 class="title">{{config.moneylify(today.total_paid_principal)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ការប្រាក់បានទូទាត់</p>
							<h3 class="title">{{config.moneylify(today.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ពិន័យបានទូទាត់</p>
							<h3 class="title">{{config.moneylify(today.total_paid_fine)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ចំណូលសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_paid_fine + today.total_paid_principal + today.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="display: flex; justify-content: space-between;">
					<h4>ប្រាក់ចំណូលខែ{{config.monthKHList[(new Date()).getMonth()]}}</h4>
					<a :href="'#/print_monthly_report'" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>បោះពុម្ភរបាយការណ៍</md-tooltip>
						</md-button>
					</a>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ដើមបានទូទាត់</p>
							<h3 class="title">{{config.moneylify(month.total_paid_principal)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ការប្រាក់បានទូទាត់</p>
							<h3 class="title">{{config.moneylify(month.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ពិន័យបានទូទាត់</p>
							<h3 class="title">{{config.moneylify(month.total_paid_fine)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ប្រាក់ចំណូលសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_paid_fine + month.total_paid_principal + month.total_paid_interest)}}</h3>
						</template>
					</stats-card>
				</div>

				<md-card>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="display: flex; justify-content: space-between;">
								<h4>ស្វែងរកទិន្នន័យ</h4>
								<a :href="'#/print_custom_report/' + (new Date(this.range_data.start_date)).getTime() + '/' + (new Date(this.range_data.end_date)).getTime()" target="_blank" v-if="this.range_data.start_date && this.range_data.end_date">
									<md-button class="md-just-icon md-simple md-primary">
										<md-icon>print</md-icon>
										<md-tooltip>បោះពុម្ភរបាយការណ៍</md-tooltip>
									</md-button>
								</a>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-field>
									<label>ថ្ងៃចាប់ផ្តើម</label>
									<md-input type="text" v-model="range_data.start_date" style="display:none" />
									<datetime type="datetime" v-model="range_data.start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">

								<md-field>
									<label>ថ្ងៃបញ្ចប់</label>
									<md-input type="text" v-model="range_data.end_date" style="display:none" />
									<datetime type="datetime" v-model="range_data.end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" style="width:100%" @click="getData()">បង្ហាញ</md-button>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ប្រាក់ដើមបានទូទាត់</p>
										<h3 class="title">{{config.moneylify(range.total_paid_principal)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ការប្រាក់បានទូទាត់</p>
										<h3 class="title">{{config.moneylify(range.total_paid_interest)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ប្រាក់ពិន័យបានទូទាត់</p>
										<h3 class="title">{{config.moneylify(range.total_paid_fine)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ប្រាក់ចំណូលសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_paid_fine + range.total_paid_principal + range.total_paid_interest)}}</h3>
									</template>
								</stats-card>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			StatsCard,
			Datetime
		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
			this.$http.get(this.config.api + "/admin/get/stat/today").then(data => {
				this.today = data.body.data
			});
			this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
				this.month = data.body.data
			});
			this.$http.get(this.config.api + "/admin/get/stat/monthly_payment").then(data => {
				this.stat_monthly_payment= data.body.data
			});
		},
		computed: {
		},
		methods: {
			getData() {
				let start_date = (new Date(this.range_data.start_date)).getTime();
				let end_date = (new Date(this.range_data.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/by_range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
				});
			},
			print() {
				var printContent = document.getElementById("report").innerHTML;
				var originalContent = window.document.body.innerHTML;
				window.document.body.innerHTML = printContent;
				window.print();
				window.document.body.innerHTML = originalContent;
			}
		},
		data() {
			return {
				loaded: false,
				range_data: {
					start_date: "",
					end_date: "",
				},
				stat: {
					total_admin: 0,
					total_loan: 0,
					total_project: 0,
					total_finish_loan: 0,
					total_client: 0,
					total_principal: 0,
					total_interest: 0,
					total_paid_principal: 0,
					total_paid_interest: 0
				},
				stat_monthly_payment: {
					total_paid_principal:0,
					total_paid_interest: 0,
					total_principal: 0,
					total_interest: 0
				},
				today: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				},

				month: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				},
				range: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue